var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('headerComponent',{attrs:{"tab":_vm.tab,"title":'前台书城',"slideData":_vm.slideData},on:{"headerTabBack":_vm.headerTabBack}}),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c(_vm.tab,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }